export default {
  state: {
    getServiceTypesByCountry: [],
    getPrices: [],
    getPendingActivities: [],
    getActivityRates: []
  },

  getters: {
    getServiceTypesByCountry: state => state.getServiceTypesByCountry,
    getPrices: state => state.getPrices,
    getPendingActivities: state => state.getPendingActivities,
    getActivityRates: state => state.getActivityRates
  },

  mutations: {
    setServiceTypesByCountry(state, val) {
      if (val) {
        state.getServiceTypesByCountry = {
          rows: val.data.map(el => ({...el, text: el.name}))
        }
      } else {
        state.getServiceTypesByCountry = {
          rows: []
        }
      }
    },
    setPrices(state, val) {
      if (val) {
        state.getPrices = {
          rows: val.data
        }
      } else {
        state.getPrices = {
          rows: []
        }
      }
    },
    setPendingActivities(state, val) {
      state.getPendingActivities = {
        rows: val.data
      }
    },
    setActivityRates(state, val) {
      state.getActivityRates = {
        rows: val.data
      }
    }
  }
}
